// extracted by mini-css-extract-plugin
module.exports = {"nom":"SemainesBar_nom__1LDeX","title":"SemainesBar_title__3fov8"};